import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import EditFeature from "@/components/POI/EditFeature/EditFeature.vue";
import "./GlobalFeatureConfig.scss";
import { PoiSteps } from "@/helpers/poiHelper";

export default {
  name: "GlobalFeatureConfig",
  props: [
    "featureGroups",
    "selectedFeatureGroups",
    "width",
    "buttonText",
    "global",
    "isPoiAdmin"
  ],
  data: () => ({
    showFeatureInput: false,
    createIsValid: false,
    isValid: false,
    editedFeature: {
      title: "",
      shortTitle: "",
      pictureURL: "",
      mappingField: "",
      group: "",
      isHighlight: false,
      visible_to: "all",
      editable_by: "all",
      internal_control_feature: false
    },
    selectedGroup: {},
    showCreateInput: false,
    createInputValue: "",
    createInputGroups: [],
    createInputTypes: [],
    createInputValid: false,
    poiSteps: PoiSteps
  }),
  async mounted() {
    await this.$store.dispatch("getCategoryGroups");
    await this.$store.dispatch("getCategoryTypes", true);
  },
  methods: {
    toggleFeatureInput(id) {
      if (this.editedFeature?.featureGroup === id) {
        this.showFeatureInput = !this.showFeatureInput;
        this.editedFeature.featureGroup = this.showFeatureInput ? id : null;
      } else {
        this.showFeatureInput = true;
        // If only the featureGroup is set, the component doesn't rerender
        this.editedFeature = { ...this.editedFeature, featureGroup: id };
      }
    },
    async saveFeature(feature, method = "put") {
      const headers = getTokenHeader();
      try {
        const res = await axios[method](
          `${env.poi_api_client_url}feature/${
            method === "put" ? feature._id : ""
          }`,
          feature,
          { headers }
        );
        if (res.status === 200 || res.status === 201) {
          this.$emit("success", "Erfolgreich gespeichert!");
          this.editedFeature = null;
          this.showFeatureInput = false;

          // No need to wait for this dispatch here
          // noinspection ES6MissingAwait
          this.$store.dispatch("getGlobalFeatureGroups");
        }
      } catch (ex) {
        this.emit("error", ex);
      }
    },
    async deleteGroup(group) {
      try {
        const confirmRes = await this.$confirm(
          `Wollen Sie die Gruppe wirklich löschen?`,
          confirmWarningConfig
        );
        if (confirmRes) {
          const headers = getTokenHeader();
          const res = await axios.delete(
            `${env.poi_api_client_url}featureGroup/${group._id}`,
            { headers }
          );
          if (res.status === 200) {
            await this.$store.dispatch("getGlobalFeatureGroups");

            this.$emit("success", "Erfolgreich gelöscht!");
            this.snackbarColor = "#00636C";
            this.snackbar = true;
          } else
            this.emit(
              "error",
              `Deletion failed with status: ${res.status}, reason: (${res.statusText})`
            );
        }
      } catch (ex) {
        this.emit("error", ex);
      }
    },
    async deleteFeature(featureId) {
      if (featureId) {
        try {
          const confirmRes = await this.$confirm(
            `Wollen Sie dieses Merkmal wirklich löschen?`,
            confirmWarningConfig
          );
          if (confirmRes) {
            const headers = getTokenHeader();
            const res = await axios.delete(
              `${env.poi_api_client_url}feature/${featureId}`,
              { headers }
            );
            if (res.status === 200) {
              // No need to wait for this dispatch here
              // noinspection ES6MissingAwait
              this.$store.dispatch("getGlobalFeatureGroups");
              this.$emit("success", "Feature wurde erfolgreich gelöscht");
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  },
  computed: {
    allFeatureGroups() {
      return this.$store.state.globalFeatureGroups;
    },
    cSelectedFeatureGroups: {
      get() {
        return this.selectedFeatureGroups;
      },
      set(val) {
        this.$emit("setFeatureGroups", val);
      }
    },
    categoryGroups() {
      return this.$store.state.categoryGroups;
    },
    categoryTypes() {
      return this.$store.state.categoryTypes;
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    }
  },
  watch: {
    async selectedPrincipal() {
      await this.$store.dispatch("getCategoryGroups");
    }
  },
  components: { EditFeature }
};
